import React from 'react'
import { Container,Row,Col } from 'reactstrap';




import Navcomponent from './Navcomponent'

const Headercomponent=()=>{
    return(<Container fluid={true} style={{
        backgroundColor: '#211F1D',
        width: '100%',
        height: '68px',
        color:'white',
        paddingTop:'3px',
     
        
      }}>
        <Row >
            <Col  className="mt-3 "  >
           
            <Navcomponent></Navcomponent>
            </Col>
        </Row>         
            </Container>
    )
}

 export default Headercomponent